import { BlockSortDirection } from 'constants-content';

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use SortByLabelEnum from application-types instead.
 */
export enum SortByLabelEnum {
  StartDate = 'Start Date',
  EndDate = 'End Date',
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use SortByEnum from application-types instead.
 */
export enum SortByEnum {
  StartDate = 'startDate',
  EndDate = 'endDate',
  LiveDate = 'liveDate',
  UnpublishDate = 'unpublishDate',
}

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use SortByMap from application-types instead.
 */
export const SortByMap = new Map<string, string>([
  [SortByLabelEnum.StartDate, SortByEnum.StartDate],
  [SortByLabelEnum.EndDate, SortByEnum.EndDate],
]);

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use SortDirectionLabelEnum from application-types instead.
 */
export enum SortDirectionLabelEnum {
  Asc = 'Newest to Oldest',
  Desc = 'Oldest to Newest',
}

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use SortPropertyType from application-types instead.
 */
export type SortPropertyType = {
  sortBy: SortByEnum;
  sortDirection: BlockSortDirection;
};

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use SortDirectionMap from application-types instead.
 */
export const SortDirectionMap = new Map<string, string>([
  [SortDirectionLabelEnum.Asc, BlockSortDirection.Asc],
  [SortDirectionLabelEnum.Desc, BlockSortDirection.Desc],
]);

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use SortByLabelToSchema from application-types instead.
 */
export const SortByLabelToSchema = Object.values(SortByLabelEnum).map(
  value => ({
    label: value,
    value: SortByMap.get(value),
  })
);

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use SortDirectionLabelToSchema from application-types instead.
 */
export const SortDirectionLabelToSchema = Object.values(
  SortDirectionLabelEnum
).map(value => ({
  label: value,
  value: SortDirectionMap.get(value),
}));
